import React from 'react';
import { Box } from '../../../../../../CommonComponents/OPL/Box/Box';
import { VisualPickerButtonContainer } from '../../../../../../CommonComponents/OPL/VisualPickerButton/VisualPickerButtonContainer';
import { Text } from '../../../../../../CommonComponents/OPL/Text/Text';
import { Lozenge } from '../../../../../../CommonComponents/OPL/Lozenge/Lozenge';
import { CardContent, CardHeader, CardWrapper } from './GoalCard.styles';
import { Icon } from '../../../../../../CommonComponents/OPL/Icon/Icon';

interface Props {
  ctaText: string;
  onClick(): void;
  hideFooter: boolean;
  icon: React.ReactNode;
  children: React.ReactNode;
  title: string;
  isCompleted?: boolean;
  showCompletedLozenge?: boolean;
}

export const GoalCard = ({
  title,
  icon,
  ctaText,
  hideFooter,
  showCompletedLozenge,
  isCompleted,
  children,
  onClick,
}: Props) => {
  return (
    <Box as="li">
      <VisualPickerButtonContainer css="width: 100%; height: 100%" onClick={onClick}>
        <CardWrapper>
          <CardHeader>
            <Box display="flex" alignItems="center" style={{ gap: 8 }}>
              {icon}

              <Text fontSize="h5" fontWeight={600}>
                {title}
              </Text>
            </Box>

            {showCompletedLozenge && (
              <Lozenge variantColor={isCompleted ? 'primary' : 'default'}>
                {isCompleted ? 'Completed' : 'Incomplete'}
              </Lozenge>
            )}
          </CardHeader>

          <CardContent>
            <Box>{children}</Box>

            {!hideFooter && (
              <Box display="flex" mt="16" alignItems="center">
                <Text color="primary.500" fontWeight={500} mr="8">
                  {ctaText}
                </Text>

                <Icon className="far fa-chevron-right" fontSize="small" color="primary.500" />
              </Box>
            )}
          </CardContent>
        </CardWrapper>
      </VisualPickerButtonContainer>
    </Box>
  );
};
